import { reportType } from "../constants/Constants"

export const isFullMedsReport = (reportTypeParam: String) => {
  return reportTypeParam === reportType.fullMedication;
}

export const isPsychotropicReport = (reportTypeParam: String) => {
  return reportTypeParam === reportType.pgxMentalHealth;
}